<template>
  <div class="share">
    <div class="share-text">SHARE:</div>
    <ul class="share-list">
      <li class="share-list-item">
        <a :href="`https://www.linkedin.com/shareArticle?url=${url}&title=${title}&source=yachtinteriorsociety.com`" target="_blank">
          <Icon name="linkedin" />
        </a>
      </li>
      <li class="share-list-item">
        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`" target="_blank">
          <Icon name="facebook" />
        </a>
      </li>
      <li class="share-list-item">
        <a :href="`https://pinterest.com/pin/create/button/?url=${url}&media=${image}&description=${title}`" 
          target="_blank"
          v-if="!isMobile"
        >          
          <Icon name="pinterest" />
        </a>
        <a :href="`https://pinterest.com/pin/create/button/?url=${url}`" 
          target="_blank"
          v-if="isMobile"
        >          
          <Icon name="pinterest" />
        </a>
      </li>
      <!-- <li class="share-list-item">
        <a :href="`http://www.linkedin.com/shareArticle?url=${url}`" target="_blank">
          <Icon name="instagram" />
        </a>
      </li> -->
      <li class="share-list-item">           
          <a :href="`https://twitter.com/intent/tweet?text=${title}&url=${url}&image=${image}&related=yachtinteriorsociety`" target="_blank">
          <Icon name="twitter" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Icon from "@/components/Icon";
// import pinterest from "https://assets.pinterest.com/js/pinit.js";
import { mapGetters } from "vuex";
export default {
  name: "Share",
  components: {
    Icon
  },
  props: {
    url: String,
    image: String,
    title: String
  },
  computed: mapGetters(["isMobile"]),
  methods: {
    util: function () {
      // this.PinUtils.pinAny();
    }
  }
};
</script>

<style lang="scss">
.share {
  display: flex;
  align-items: center;
  .share-text {
    font-size: 16px;
    text-transform: uppercase;
    height: 10px;
    margin-right: 15px;
  }
  .share-list {
    display: flex;
    .share-list-item {
      margin: 0 15px;
      .icon {
        svg {
          path {
            transition: all 0.3s;
          }
        }
      }
      &:hover {
        .icon {
          svg {
            path {
              fill: $pink;
            }
          }
        }
      }
    }
  }
}
</style>